module.exports = __webpack_public_path__ + "img/singup12.fd5fee94.jpg";